import { useEffect, useState } from 'react';

/** Matches ZOE Agents tab placeholder typewriter speed. */
const TYPING_INTERVAL_MS = 22;

/**
 * Reveals `text` character-by-character for input placeholders.
 * Respects prefers-reduced-motion (shows full text immediately).
 */
export function useTypingPlaceholder(text: string, enabled = true): string {
  const [typed, setTyped] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled) {
      setTyped(text);
      return;
    }

    const prefersReduced =
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduced) {
      setTyped(text);
      return;
    }

    let i = 0;
    setTyped('');
    const id = window.setInterval(() => {
      i += 1;
      setTyped(text.slice(0, i));
      if (i >= text.length) {
        window.clearInterval(id);
      }
    }, TYPING_INTERVAL_MS);

    return () => window.clearInterval(id);
  }, [text, enabled]);

  return typed ?? '';
}
